exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".lpContainer{width:720px;margin:0 auto}.lpContainer img{width:100%;margin-bottom:10px;border:1px solid #ced0d1}.section{margin-bottom:40px}.section a{text-decoration:underline}.section .sectionInner{margin-bottom:25px}.sectionHeading{margin-bottom:20px;padding-bottom:10px;border-bottom:2px solid #da5872}", ""]);

// exports
